// @flow
import React from 'react'
import Loadable from 'react-loadable'

const LoadableHtmlRender = Loadable({
  loader: () => import('./HtmlRender'),
  loading() { return <span /> },
})

export default LoadableHtmlRender
